<h5 class="references-info-headline">
  {{ 'booking.form.headline.references' | transloco }}
</h5>
<form class="references-form" [formGroup]="referencesForm">
  <markant-input
    data-cy="customer-service-reference-id-input"
    formControlName="customerCartridgeReferenceId"
    [outlined]="true"
    [label]="'booking.form.formFields.customerReference' | transloco"
    [placeholder]="'booking.form.formFields.customerReference' | transloco"
    [showLabelHint]="true"
  ></markant-input>
  <markant-input
    data-cy="cost-center-input"
    formControlName="costCenter"
    [outlined]="true"
    [label]="'booking.form.formFields.costCentre' | transloco"
    [placeholder]="'booking.form.formFields.costCentre' | transloco"
    [showLabelHint]="true"
  ></markant-input>
  <markant-input
    data-cy="other-reference-input"
    formControlName="otherReferences"
    [outlined]="true"
    [label]="'booking.form.formFields.reference' | transloco"
    [placeholder]="'booking.form.formFields.reference' | transloco"
    [showLabelHint]="true"
  ></markant-input>
</form>
